<template>
    <WaitingBlock v-if="isLoadingDayTemplate || viewState.isLoadingDayTemplateAds"></WaitingBlock>

    <section class="page-section" v-else="currentDayTemplate != null">
        <ErrorPage v-if="adsResponse && adsResponse.errors && adsResponse.errors.length > 0">
            <template slot="Title">
                Application Error
            </template>
            <template slot="SubTitle">
            </template>
            <template slot="Content">
                <p v-for="error in adsResponse.errors">{{error}}</p>
            </template>
            <template slot="Actions">
                &nbsp;
            </template>
        </ErrorPage>
        <ErrorPage v-else-if="adBreaks == null || adBreaks.length === 0">
            <template slot="Title">
                Ad config error
            </template>
            <template slot="SubTitle">
            </template>
            <template slot="Content">
                No valid ad configuration has been found
            </template>
            <template slot="Actions">
                &nbsp;
            </template>
        </ErrorPage>
        <template v-else>
<!--            <div v-if="adsNotValid" class="alert alert-warning">-->
<!--                <span>It seems that you have some ad break with a wrong interval value.</span> <br>-->
<!--                <span>Ad break must be separated of at least 10 minutes</span>-->
<!--            </div>-->
            <div class="zone toggle-container">
                <Button class="switch" :empty="true" :noBorder="true"
                        @click.prevent="(viewState.applyAll = !viewState.applyAll) & updateAds(0) & saveDayTemplateAds()">
                    <i :class="['fas', 'fa-check', {'checked':viewState.applyAll}]"></i>
                </Button>
                <div class="label">
                    Apply same pattern for each hour
                </div>
            </div>
            <div class="zone">
                <div v-for="(hourOfDay, indexHour) in adBreaks"
                     v-if="!viewState.applyAll ||indexHour <1"
                     :key="indexHour"
                     class="slider-container">
                    <div class="label">{{pad.call(indexHour)}}:00</div>
                    <div class="slider"
                         @mousemove="trackMouseCoordinate"
                         @mouseleave="updateAds(indexHour) & deactivateHandler()"
                         @mouseup="updateAds(indexHour)& deactivateHandler()">
                        <div class="slider-bar">
                        </div>
                        <div v-for="(min,indexBreak) in hourOfDay"
                             :class="['handler', { active: isCurrentHandler(indexHour, indexBreak) }, {error: isOverlap && currentAdBreak.hIndex === indexHour && currentAdBreak.mIndex === indexBreak} ]"
                             :style="{ 'left':'calc('+(min%60.0/0.6)+'% - 22.5px)' }"
                             @mousedown="activateHandler(indexHour, indexBreak)"
                             @mouseup="updateAds(indexHour)">
                            <div>{{pad.call(indexHour)}}:{{pad.call(min%60)}}</div>
                        </div>
                    </div>
                    <div class="button-container">
                        <button @click.prevent="removeBreak(indexHour)"><i class="fas fa-minus"></i></button>
                        <button @click.prevent="addBreak(indexHour)"><i class="fas fa-plus"></i></button>
                    </div>
                </div>
            </div>
        </template>
        <b-toast id="error-interval" title="Wrong ad break values" variant="warning" no-auto-hide>
            <span>It seems that you have some ad break with a wrong interval value.</span> <br>
            <span>Ad break must be separated of at least 10 minutes</span>
        </b-toast>
    </section>
</template>

<script>
    import store from '@/store/index.js';
    import WaitingBlock from '@/components/common/WaitingBlock.vue';
    import ItemListCard from '@/components/common/PlannerItemListCard.vue';
    import Button from '@/components/common/Button.vue';
    import Translations from '@/store/translations';
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Apis from "@/apis";
    import {HTTP} from "@/utils/http";
    import Vue from 'vue';
    import moment from 'moment';
    import ErrorPage from '@/components/common/ErrorPage';

    //import VueDraggableResizable from 'vue-draggable-resizable';
    //Vue.component('vue-draggable-resizable', VueDraggableResizable)

    export default {
        name: "DayTemplateAdBreaks",
        store,
        components: {WaitingBlock, ItemListCard, ErrorPage, Button},
        mounted() {
            this.stationUid = this.$route.params.stationUid;
            this.dayTemplateUid = this.$route.params.dayTemplateUid;
            this.loadDayTemplate();
            this.loadDayTemplateAds();
        },
        watch: {
            '$route': function (to, from) {
                this.stationUid = this.$route.params.stationUid;
                this.dayTemplateUid = this.$route.params.dayTemplateUid;
                this.loadDayTemplate();
                this.loadDayTemplateAds();
            },
            adsNotValid: {
                handler: function (newV) {
                    if(newV) {
                        this.$bvToast.show('error-interval')
                    } else {
                        this.$bvToast.hide('error-interval')
                    }
                }
            }
        },
        computed: {
            Translations: () => Translations,
            ...mapState(['isLoadingDayTemplate', 'currentDayTemplate']),
        },
        data() {
            const ads = this.initNewConfig();
            return {
                viewState: {
                    activeHandler: null,
                    mouseCoordinates: {x: 0, y: 0},
                    applyAll: true,
                    isLoadingDayTemplateAds: false,
                    isSavingDayTemplateAds: false
                },
                stationUid: null,
                dayTemplateUid: null,
                adBreaks: ads,
                adsResponse: {},
                minInterval: 10,
                maxAdBreaks: 5,
                isOverlap: false,
                adsNotValid: false,
                currentAdBreak: null,
            }
        },
        methods: {
            addBreak(indexHour) {
                const currentConfig = this.adBreaks[indexHour].slice();
                // max 6 adbreaks per hour
                if (currentConfig.length <= this.maxAdBreaks - 1) {
                    currentConfig.push(59);
                    Vue.set(this.adBreaks, indexHour, currentConfig);
                    this.updateAds(indexHour);
                    this.saveDayTemplateAds();
                }
            },
            removeBreak(indexHour) {
                const currentConfig = this.adBreaks[indexHour].slice();
                currentConfig.pop();
                Vue.set(this.adBreaks, indexHour, currentConfig);
                this.updateAds(indexHour);
                this.saveDayTemplateAds();
            },
            initEmptyConfig: () => {
                const ads = [];
                for (let i = 0; i < 24; i++) {
                    ads[i] = [];
                }
                return ads;
            },
            initNewConfig: () => {
                const ads = [];
                for (let i = 0; i < 24; i++) {
                    ads[i] = [i * 60 + 10, i * 60 + 20, i * 60 + 30];
                }
                return ads;
            },
            loadDayTemplate: function () {
                if (this.$route.params != null && this.$route.params.stationUid != null && this.$route.params.dayTemplateUid != null) {
                    store.dispatch("loadDayTemplate", this.$route.params);
                }
            },

            isCurrentHandler(hIdx, mIdx) {
                if (!this.viewState.activeHandler) return false;
                if (this.viewState.activeHandler.hIndex === hIdx && this.viewState.activeHandler.mIndex === mIdx) {
                    return true;
                }
            },
            activateHandler(hourIndex, minIndex) {
                this.currentAdBreak = {hIndex: hourIndex, mIndex: minIndex}
                this.viewState.activeHandler = {hIndex: hourIndex, mIndex: minIndex};
            },
            updateAds(hourIndex) {
                if (hourIndex != null) {
                    if (this.viewState.applyAll === true) {
                        for (let i = 0; i < 24; i++) {
                            const currentConfig = this.adBreaks[0].slice();
                            if (i !== hourIndex) {
                                for (let idx = 0; idx < currentConfig.length; idx++) {
                                    currentConfig[idx] = i * 60 + parseInt(currentConfig[idx]);

                                }
                                Vue.set(this.adBreaks, i, currentConfig);
                            }
                        }
                    }
                }

            },

            deactivateHandler(hourIndex, minIndex) {
                if (this.viewState.activeHandler != null) {
                    this.saveDayTemplateAds();
                }
                this.viewState.activeHandler = null;

            },
            checkIntervalValidity(arr){
                const diffs = arr.slice(1).map((x, i) => x - arr[i]);
                const isBelowMinInterval = (currentValue) => currentValue < this.minInterval;
                return diffs.some(isBelowMinInterval);
            },
            trackMouseCoordinate: function (event) {
                if (!this.viewState.activeHandler) return;
                const activeHandler = this.viewState.activeHandler;
                const bounds = event.currentTarget.getBoundingClientRect();
                // pass event object, bound to mouse move with updat
                this.viewState.mouseCoordinates.x = parseInt(event.clientX - bounds.x);
                this.viewState.mouseCoordinates.y = parseInt(event.clientY - bounds.y);
                // convert relative coordinate to minutes
                let minute = Math.round((this.viewState.mouseCoordinates.x / event.currentTarget.clientWidth) * 60.0);
                if (minute < 0) minute = 0;
                else if (minute > 59) minute = 50;
                const newItem = this.adBreaks[activeHandler.hIndex].slice();
                newItem[activeHandler.mIndex] = activeHandler.hIndex * 60 + minute;

                // set a boolean if one value is wrong
                this.isOverlap = this.checkIntervalValidity(newItem);

                Vue.set(this.adBreaks, activeHandler.hIndex, newItem);
                this.viewState.mouseCoordinates.event = event;
            },
            saveDayTemplateAds() {
                const ads = this.prepareApiAdBreaks(this.adBreaks);
                this.adsNotValid = this.checkIntervalValidity(ads);
                if(!this.isOverlap && !this.adsNotValid) {
                    HTTP.post(Apis.daytemplates.adBreaks, {

                        stationUid: this.stationUid,
                        dayTemplateUid: this.dayTemplateUid,
                        adBreaks: ads
                    })
                        .then(this.onAdsSaved, this.onAdsSaveError)
                        .then(this.onAdsSaveCompleted);

                }

            },
            onAdsSaved(resp) {
                this.adsResponse = resp.data;
            },
            onAdsSaveError(resp) {
                this.adsResponse = resp.data;
            },
            onAdsSaveCompleted(resp) {
                this.viewState.isSavingDayTemplateAds = false;
            },
            loadDayTemplateAds: function () {
                this.adBreaks = null;
                this.viewState.isLoadingDayTemplateAds = true;
                if (this.$route.params != null && this.$route.params.stationUid != null && this.$route.params.dayTemplateUid != null) {
                    HTTP.get(Apis.daytemplates.adBreaks, {
                        params: {
                            stationUid: this.stationUid,
                            dayTemplateUid: this.dayTemplateUid
                        }
                    })
                        .then(this.onAdsLoaded, this.onAdsLoadError)
                        .then(this.onAdsLoadCompleted);
                }
            },
            prepareApiAdBreaks: function (data) {
                const ads = [];
                for (let h = 0; h < data.length; h++) {
                    let idxValue = data[h];
                    for (let m = 0; m < idxValue.length; m++) {
                        ads.push(idxValue[m]);
                    }
                }
                return ads;
            },
            prepareViewAdBreaks: function (input) {
                const distinctSchedules = {};

                if (input != null) {
                    const ads = this.initEmptyConfig();
                    for (let i = 0; i < input.length; i++) {
                        const idx = parseInt(((parseInt(input[i]) || 0) / 60));
                        const min = parseInt(((parseInt(input[i]) || 0) % 60));
                        distinctSchedules[min] = true;
                        ads[idx].push(input[i]);
                    }
                    this.viewState.applyAll = input.length / 24 === Object.keys(distinctSchedules).length;
                    this.adBreaks = ads;
                } else {
                    // SHOULD NOT
                    this.viewState.applyAll = true;
                    this.adBreaks = this.initEmptyConfig();
                }
            },
            onAdsLoaded(resp) {
                this.adsResponse = resp.data;
                // Prepare display object
                this.prepareViewAdBreaks(resp.data.dataItem);
            },
            onAdsLoadError(resp) {
                this.adsResponse = resp.data;
            },
            onAdsLoadCompleted(resp) {
                this.viewState.isLoadingDayTemplateAds = false;
            }
        }
    }

</script>

<style lang="scss" scoped>
    @import 'global_var';

    .zone {
        margin-top: 15px;
        border-radius: 5px;
        border: 0.2px solid #C3CBDA;

    }

    .toggle-container {
        display: flex;
        position: sticky;
        top: -15px;
        background: white;
        //z-index: 2500;
    }

    .toggle-container .label {
        flex-grow: 1;
        text-align: left
    }

    .slider-container {
        display: flex;
        align-items: center;
        border: 1px solid $COLOR_ICONS;
        border-radius: 5px;
        margin-bottom: 20px;
        color: #292C33;
    }

    .toggle-container .label, .slider-container .label {
        margin: 0 0 0 30px;
        padding: 15px 0;
        font-size: 14px;
    }

    .slider-container .label {
        width: 60px;
        text-align: left;
    }

    .slider-container .slider {
        flex: 1;
        height: 50px;
        margin: 5px 25px;
        position: relative;
    }

    .slider-container .handler {
        position: absolute;
        top: calc(50% - 11px);
        cursor: pointer;
        height: 22px;
        border-radius: 20px;
        background-color: #F0F1F3;
        padding: 2px;
        text-align: center;
        width: 55px;
        font-weight: 400;
        font-size: 14px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    }

    .slider-container .handler.active {
        z-index: 150;
        background-color: var(--COLOR_BRAND);
        color: #fff;
    }

    .slider-container .handler.error {
        background-color: red;
        color: #ffffff;
    }

    .slider-container .handler div {
        pointer-events: none;
        user-select: none;
    }

    .slider-container .slider-bar {
        height: 3px;
        position: absolute;
        top: calc(50% - 1.5px);
        border-radius: 100px;
        width: 100%;
        background-color: #D2D2D2;
    }

    .button-container button {
        background: transparent;
        color: #292C33;
        border: none;
    }

    .button-container button.disabled {
        background: transparent;
        color: lightgrey;
    }

    .error{
        position: absolute;
        top: -20px;
        color: red;
        left: 0;
        width: 100%;
        text-align: center;
        height: 130px;
    }
</style>